import {
    useCallback,
} from 'react'

import {
    useMutation,
} from '@tanstack/react-query'

import simpleApi from 'app/services/simpleApi'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import requests from 'app/requests/Company.requests'
import {
    Company,
} from '../Companies.types'

export default ({
    onSuccess,
}: { onSuccess: (...args: any[]) => void }) => {
    const token = useJWTToken()

    const {
        onSuccess: onSuccessCreateCompany,
        onError,
    } = useHandleStatusRequest({
        title: 'New company was created',
        id: 'CompanyCreated',
        onSuccess,
    })

    const {
        mutate: createCompany,
    } = useMutation({
        mutationFn: (company: Company) => {
            return simpleApi({
                ...requests.create({
                    data: company,
                }),
                token,
            })
        },
        onError,
        onSuccess: onSuccessCreateCompany,
    })

    return useCallback((company: Company) => {
        createCompany(company)
    }, [createCompany])
}
